<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_60_w" v-if="!loading && dataSet && isReady">
        <v-card class="rounded_max" elevation="1" style="overflow: hidden">
          <div class="strip" :style="`background:${section.color}`"></div>
          <div class="d-flex justify-space-between px-2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                  icon
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
          </div>
          <div class="px-5 pb-5" v-if="dataSet">
            <h3>{{ dataSet.data.title }}</h3>
            <p class="my-3" v-html="dataSet.data.description"></p>
          </div>
        </v-card>

        <div class="mt-3">
          <v-card class="rounded-lg" elevation="1" v-if="dataSet">
            <div class="pa-2">
              <v-card flat color="#f6f6f6a1" class="pa-2 rounded_lg">
                <div class="pa-1 d-flex align-center justify-start">
                  <v-card
                    class="pa-3 rounded-lg d-flex justify-center align-center"
                    :color="section.color"
                    flat
                    dark
                  >
                    <v-icon>mdi-link-variant</v-icon>
                  </v-card>
                  <div class="ml-2" style="width: 80%">
                    <a
                      v-if="dataSet.detail[0].content"
                      :href="dataSet.detail[0].content"
                      target="_blank"
                    >
                      <h5 style="width: 100%">
                        {{ dataSet.detail[0].content }}
                      </h5>
                    </a>
                    <div v-if="!dataSet.detail[0].content">No Content</div>
                  </div>
                </div>
              </v-card>
              <div class="pa-2 d-flex align-center">
                <v-row no-gutters>
                  <v-col cols="12" md="7">
                    <div class="pa-2">
                      <p class="default_txt">Start Date</p>
                      <div class="mt-2 d-flex align-center">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-3">
                          {{
                            dataSet.detail[0].session_date
                              ? dataSet.detail[0].session_date
                              : "-"
                          }}
                        </h4>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="pa-2">
                      <p class="default_txt">Start Time</p>
                      <div class="mt-2 d-flex align-center">
                        <v-icon>mdi-clock-time-four-outline</v-icon>
                        <h4 class="ml-3">
                          {{
                            dataSet.detail[0].session_time
                              ? dataSet.detail[0].session_time
                              : "-"
                          }}
                        </h4>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div class="icon_gb">
              <v-icon
                size="100"
                :color="section.color"
                v-if="dataSet.mime_type == 'doc'"
                >mdi-file-document-outline</v-icon
              >
              <v-icon
                size="100"
                :color="section.color"
                v-if="dataSet.mime_type == 'video'"
                >mdi-play-box-outline</v-icon
              >
              <v-icon
                size="100"
                :color="section.color"
                v-if="dataSet.mime_type == 'audio'"
                >mdi-music</v-icon
              >
            </div>
          </v-card>
        </div>
      </div>
      <div
        v-if="!isReady"
        class="d-flex flex-column align-center justfiy-center"
      >
        <img
          src="../../../../assets/img/Halaman Unauthorized.png"
          height="300px"
          alt=""
        />
        <h3 class="mt-2">Module not ready</h3>
        <p class="default_txt">
          The module is being prepared by the administrator
        </p>
        <v-btn
          depressed
          dark
          class="mt-2"
          @click="$router.go(-1)"
          :color="section.color"
          >back</v-btn
        >
      </div>

      <div v-if="loading" class="_60_w">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pa-3">
              <v-skeleton-loader
                type="image"
                class="rounded_lg"
                height="230px"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      id: (state) => state.id,
    }),
  },
  components: { StarRating },

  name: "moduleSynchronous",
  data() {
    return {
      loadQuest: false,
      loading: true,
      dataSet: null,
      section: null,
      module: null,
      instance: null,
      answered: null,
      materi_id: null,
      isReady: false,
    };
  },
  computed: {},
  mounted() {
    let answer = JSON.parse(localStorage.getItem("answer"));
    if (answer) {
      this.answer = answer;
    }
    this.fetchSection();
    this.fetchModule();
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.section = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchModule() {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      this.loading = true;
      let data = {
        path: `scholar/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          if (data.detail.length) {
            this.isReady = true;
            this.dataSet = data;
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    fetchGb(id) {
      this.loadQuest = true;
      let data = {
        path: `manage/gudang_belajar?filter[id]=${id}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data.data[0];
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
      this.loadQuest = false;
    },
    pickAnswer(no, val) {
      let idx = null;
      let exist = this.answer.find((x) => {
        return x.no == no;
      });
      if (exist) {
        idx = this.answer.findIndex((el) => el.no === no);
        this.answer[idx].val = val;
      } else {
        this.answer.push({
          no: no,
          val: val,
        });
      }
      localStorage.setItem("answer", JSON.stringify(this.answer));
    },

    finish() {
      let opini = JSON.parse(localStorage.getItem("answer"));
      let answer = {};
      opini.forEach((el) => {
        answer[el.no] = el.val;
      });
      this.d_type = "s_quiz";
      this.d_title = "";
      this.inventory = answer;
      this.d_small = true;
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.card_gb {
  position: relative;
  overflow: hidden;
}
.content_gb {
  position: relative;
  z-index: 3;
  background: #f6f6f6a1;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
</style>
